/** Prefer server error text for action toasts (never silent empty). */
export function actionErrorMessage(e: unknown, fallback: string): string {
  if (e instanceof Error && e.message.trim()) return e.message
  return fallback
}
